// Generated by CoffeeScript 1.10.0
(function() {
  var defaultValue, dereference, generateExample;

  dereference = require('./dereference');

  defaultValue = function(type) {
    switch (type) {
      case 'boolean':
        return true;
      case 'number':
        return 1;
      case 'string':
        return 'Hello, world!';
    }
  };

  generateExample = function(root) {
    var i, item, j, key, len, len1, member, obj, ref, ref1, ref2, results;
    switch (root.element) {
      case 'boolean':
      case 'string':
      case 'number':
        if (root.content != null) {
          return root.content;
        } else {
          if (((ref = root.attributes) != null ? ref["default"] : void 0) !== void 0) {
            return root.attributes["default"];
          } else {
            return defaultValue(root.element);
          }
        }
        break;
      case 'enum':
        return generateExample(root.content[0]);
      case 'array':
        ref1 = root.content || [];
        results = [];
        for (i = 0, len = ref1.length; i < len; i++) {
          item = ref1[i];
          results.push(generateExample(item));
        }
        return results;
        break;
      case 'object':
        obj = {};
        ref2 = root.content;
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          member = ref2[j];
          if (member.element === 'select') {
            member = member.content[0].content[0];
          }
          key = member.content.key.content;
          obj[key] = member.content.value ? generateExample(member.content.value) : defaultValue('string');
        }
        return obj;
    }
  };

  module.exports = function(root, dataStructures) {
    return generateExample(dereference(root, dataStructures));
  };

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/eidolon/lib/example.js
 ** module id = 164
 ** module chunks = 0
 **/